import React, { useState } from "react";
import axios from "axios";
import apiUrl from "../../Environment/Api";
import { useNavigate } from "react-router-dom";

function Passwordchange() {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setErrorMessage("New password and confirm password must match.");
            return;
        }
        try {
            const response = await axios.post(apiUrl + "/change-password", { oldPassword, newPassword });
            console.log("Password change successful:", response.data.message);
            setSuccessMessage(response.data.message);
            setTimeout(() => {
                navigate('/dashboard');
            }, 1000);
            setErrorMessage("");
        } catch (error) {
            console.error("Password change failed:", error.response.data);
            setErrorMessage(error.response.data.message || "Password change failed.");
            setSuccessMessage("");
        }
    };

    return (
        <div className="mainDiv">
            <div className="cardStyle">
                <form onSubmit={handleSubmit} name="changePasswordForm" id="changePasswordForm">
                    <h2 className="formTitle">Change Your Password</h2>
                    <div className="inputDiv pt-3">
                        <label className="inputLabel control-label" htmlFor="oldPassword">Old Password</label>
                        <input type="password" id="oldPassword" name="oldPassword" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} required />
                    </div>
                    <div className="inputDiv">
                        <label className="inputLabel" htmlFor="newPassword">New Password</label>
                        <input type="password" id="newPassword" name="newPassword" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
                    </div>
                    <div className="inputDiv">
                        <label className="inputLabel" htmlFor="confirmPassword">Confirm Password</label>
                        <input type="password" id="confirmPassword" name="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                    </div>
                    {errorMessage && <p className="errorText text-danger">{errorMessage}</p>}
                    {successMessage && <p className="successText text-success">{successMessage}</p>}
                    <div className="buttonWrapper">
                        <button type="submit" className="submitButton pure-button pure-button-primary">
                            <span>Continue</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Passwordchange;
